<script lang="ts">
    import cn from 'classnames';
    import { SvgIcon } from '@uikit/svg-icon';

    import { type Action, setActionFunc } from '@uikit/actions';

    import { type Props as SegmentControlProps, TagName } from './types';
    import s from './segment-control.module.css';

    type Props = SegmentControlProps<Record<string, string>>;

    export let list: Props['list'];
    export let active: Props['active'];
    export let bold: Props['bold'] = false;
    export let isActiveClikable: Props['isActiveClikable'] = false;
    export let tagName: Props['tagName'] = TagName.Button;
    export let classes: Props['classes'] = '';
    export let activeClasses: Props['activeClasses'] = '';
    export let rootClasses: Props['rootClasses'] = '';
    export let hasDataValue: Props['hasDataValue'] = false;
    export let action: Action | undefined = undefined;

    $: ({ actionFunc, actionParams } = setActionFunc(action));
</script>

<div class={cn(s.root, { [s.bold]: bold }, rootClasses)} use:actionFunc={actionParams}>
    {#each list as { href, value, icon, text, componentLeft, componentRight }}
        {@const dataValue = hasDataValue ? value : null}
        {@const isActive = active === value || active === dataValue}
        <!-- svelte-ignore a11y-no-static-element-interactions -->
        <svelte:element
            this={tagName}
            on:click
            on:keydown
            on:keypress
            on:keyup
            href={(isActive && !isActiveClikable) || tagName === TagName.Button ? null : href}
            class={cn(s.button, classes, { [s.active]: isActive, [activeClasses]: isActive })}
            value={tagName === TagName.Button ? value : null}
            data-value={dataValue}
            type={tagName === TagName.Button ? 'button' : null}
        >
            {#if icon}
                <SvgIcon classes={s.icon} {icon} />
            {:else}
                {#if componentLeft}
                    <svelte:component
                        this={componentLeft.component}
                        {...componentLeft.props}
                        classes={cn(s.componentLeft, `${componentLeft.classes ?? ''}`)}
                    />
                {/if}
                {text}
                {#if componentRight}
                    <svelte:component
                        this={componentRight.component}
                        {...componentRight.props}
                        classes={cn(s.componentRight, `${componentRight.classes ?? ''}`)}
                    />
                {/if}
            {/if}
        </svelte:element>
    {/each}
</div>
